import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const TicketPipelineStageInput = ({
  canEditProperty,
  label,
  onChange,
  options,
  value
}) => /*#__PURE__*/_jsx(FormControl, {
  "aria-label": label,
  required: true,
  labelTooltip: !canEditProperty ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-workspace-ui-lib.ticket-header.changePipelineModal.readOnlyProperty"
  }) : undefined,
  children: /*#__PURE__*/_jsx(Select, {
    onChange: onChange,
    options: options,
    value: value
  })
});
TicketPipelineStageInput.displayName = 'TicketPipelineStageInput';
export default TicketPipelineStageInput;